export const ValidationMessages = {
    Required: "required",
    invalidPhoneNumber: "invalid phone number",
    email: "invalid email",
};
